// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import {Accordeon} from './util/accordeon';
import {LinkImageHover} from './util/linkImageHover';
import {CustomSlider} from './util/slider';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
    common,
});

jQuery(document).ready(() => {
    routes.loadEvents()
    new Accordeon('.plus-section__accordeon__item', '.plus-section__accordeon__item__content');
    new LinkImageHover();
    new CustomSlider();
    new Accordeon('.labels-section__accordeon__item', '.labels-section__accordeon__item__content');
    new Accordeon('.simple-accordeon_item', '.simple-accordeon_container');
});



// WEBPACK FOOTER //
// ./js/main.js